










































































import Vue from 'vue'

export default Vue.extend({
  props: {
    transaction: {
      type: Object,
      default: null
    }
  },

  computed: {
    hasTransaction(this: any): boolean {
      const t = this.transaction
      return !!(
        t &&
        typeof t === 'object' &&
        (t.reference || t.amount || t.status || t.id || t._id)
      )
    }
  }
})
